<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">員工資料</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Project Type -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="員工編號："
                  label-for="id"
                  label-cols-md="3"
                  class="required"
                >
                  <div class="">
                    {{
                      newStaffData.id
                        ? newStaffData.user_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_is_active"
                >
                  <b-form-group
                    label="狀態："
                    label-for="is_active"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="is_active"
                      v-model="newStaffData.is_active"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="staffStatusOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="Select staff status"
                      :filter="workerStatusSearch"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                  <b-form-group
                    label="中文姓名："
                    label-for="name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="name_cn"
                      v-model="newStaffData.name_cn"
                      placeholder="輸入中文姓名"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                >
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="newStaffData.name"
                      placeholder="輸入系統帳號名稱"
                      :state="getValidationState(validationContext)"
                      @blur="checkUserName"
                    />
                    <label
                      v-if="errorNameMessage && newStaffData.name"
                      class="text-danger"
                    >
                      {{ errorNameMessage }}
                    </label>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required|email"
                  vid="v_email"
                >
                  <b-form-group
                    label="電郵地址："
                    label-for="email"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="email"
                      v-model="newStaffData.email"
                      placeholder="輸入電郵地址"
                      :state="getValidationState(validationContext)"
                      @blur="checkUserEmail"
                    />
                    <label v-if="errorEmailMessage && newStaffData.email" class="text-danger">
                      {{ errorEmailMessage }}
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- gender -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_gender_id"
                >
                  <b-form-group
                    label="性別"
                    label-for="gender"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-radio-group
                      v-slot="{ ariaDescribedby }"
                      style="margin-top: 10px"
                      v-model="newStaffData.gender_id"
                      name="gender"
                    >
                      <b-form-radio
                        name="radio-options"
                        :aria-describedby="ariaDescribedby"
                        v-for="gender of genderOptions"
                        :key="gender.name + gender.id"
                        :value="gender.id"
                        >{{ gender.name }}</b-form-radio
                      >
                    </b-form-radio-group>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- id_number -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_id_number"
                >
                  <b-form-group
                    label="身份證號碼："
                    label-for="id_number"
                    label-cols-md="3"
                    class="required"
                  >
                    <!--
                <masked-input class="form-mark-input"
                    mask="*******\(*\)"
                    id="id_number"
                    v-model="newStaffData.id_number"

                    placeholder="輸入身份證號碼" /> -->

                    <b-form-input
                      id="id_number"
                      v-model="newStaffData.id_number"
                      @input="IsHKID(newStaffData.id_number)"
                      :state="getValidationState(validationContext)"
                      placeholder="輸入身份證號碼"
                    />
                    <b-form-invalid-feedback :force-show="true">
                      {{ idError ? idError : validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- date_of_birth -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="出生日期"
                  rules="required"
                > -->
                  <b-form-group
                    label="出生日期："
                    label-for="date_of_birth"
                    label-cols-md="3"
                  >
                    <flat-pickr
                      v-model="newStaffData.date_of_birth"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        maxDate: 'today',
                        dateFormat: 'Y-m-d',
                        maxDate: maxDate,
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <!-- :state="getValidationState(validationContext)" -->
                    <!-- <b-form-invalid-feedback
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                  </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_phone"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="staff_phone"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="staff_phone"
                      v-model="newStaffData.phone"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                      @blur="handlePhoneChange"
                    />
                    <label v-if="errorPhoneMessage && newStaffData.phone" class="text-danger">
                      {{ errorPhoneMessage }}
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- address -->
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>住宅地址：</label>
                  <div class="input_wrap">

                      <b-form-input
                        id="c_address"
                        v-model="newStaffData.address"
                        placeholder="輸入住宅地址"

                      />
                  </div>
                </div>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_payment_method_id"
                >
                  <b-form-group
                    label="計薪形式："
                    label-for="payment_method_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="payment_method_id"
                      v-model="newStaffData.payment_method_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="paymentMethodStatusOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇計薪形式"
                      :filter="paymentMethodSearch"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_bank_id"
                > -->
                  <b-form-group
                    label="銀行名稱："
                    label-for="bank_id"
                    label-cols-md="3"
                  >
                  <!-- class="required" -->
                    <v-select
                      id="bank_id"
                      v-model="newStaffData.bank_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="bankOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇銀行名稱"
                      :filter="bankSearch"
                    >
                    </v-select>
                    <!-- <b-form-invalid-feedback
                    :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                  </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_bank_account"
                > -->
                  <b-form-group
                    label="戶口號碼："
                    label-for="bank_account"
                    label-cols-md="3"
                  >
                  <!-- class="required" -->
                    <b-form-input
                      id="bank_account"
                      v-model="newStaffData.bank_account"
                      placeholder="輸入戶口號碼"
                    />
                    <!-- :state="getValidationState(validationContext)"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                  </b-form-group>
                <!-- </validation-provider> -->
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="支付帳號名稱：" label-for="bank_account_name" label-cols-md="3">
                  <b-form-input
                    id="bank_account_name"
                    v-model="newStaffData.bank_account_name"
                    placeholder="輸入支付帳號名稱"
                  />
                </b-form-group>
              </b-col>
              <!--    <b-col cols="12">
                <hr />
              </b-col>
              <b-col cols="12">
              <upload-file title="身分證證明" v-on:file-uploaded="onFileUploaded"></upload-file>
              </b-col> -->
              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_position"
                >
                  <b-form-group
                    label="職位："
                    label-for="position"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="position"
                      v-model="newStaffData.position"
                      placeholder="輸入職位"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="部門：" label-for="department" label-cols-md="3">
                  <b-form-input
                    id="department"
                    v-model="newStaffData.department"
                    placeholder="輸入部門"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_join_date"
                >
                  <b-form-group
                    label="加入日期："
                    label-for="join_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newStaffData.join_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                    :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_role_name"
                >
                  <b-form-group
                    label="權限："
                    label-for="role_name"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="role_name"
                      v-model="newStaffData.role_name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="roleOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.name"
                      placeholder="選擇權限"
                      :filter="roleSearch"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                    :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- <b-col cols="12" md="6">
                  <b-form-group
                    label="狀態："
                    label-for="is_active"
                    label-cols-md="3"
                  >
                  <b-form-checkbox
                      style="margin-top: 5px"
                      checked="true"
                      value="1"
                      v-model="newStaffData.is_active"
                      class="custom-control-success"
                      name="check-button"
                      switch
                      inline
                    />

                    <span style="position: relative; top: -5px">{{
                      newStaffData.is_active ? "啟用" : "禁用"
                    }}</span>
                  </b-form-group>
              </b-col> -->
              <b-col cols="12" md="12">
                <hr />
              </b-col>

              <b-col cols="12">
                <upload-file
                  key="fileupload1"
                  ref="childRef1"
                  custome_id="1"
                  title="⾝份証明⽂件"
                  :props_previewImage="props_previewImage"
                  v-on:file-uploaded="onFileUploaded"
                  file_delete_url="/user_documents"
                ></upload-file>
              </b-col>
            </b-row>
            <b-row class="mt-1" v-if="newStaffData.id == 0">
              <!-- Field: Password -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="密碼"
                  rules="required|min:8"
                  vid="v_password"
                >
                  <b-form-group
                    class="required"
                    label="密碼"
                    label-for="password"
                    label-cols-md="3"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password"
                        :type="passwordFieldType"
                        :state="getValidationState(validationContext)"
                        v-model="newStaffData.password"
                        name="password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- Field: Password Confirm -->
              <b-col cols="12" md="6" v-if="newStaffData.id == 0">
                <validation-provider
                  #default="validationContext"
                  name="確認密碼"
                  rules="required|min:8|confirmed:v_password"
                  vid="v_password_confirmation"
                >
                  <b-form-group
                    class="required"
                    label="確認密碼"
                    label-for="password_confirmation"
                    label-cols-md="3"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password_confirmation"
                        :type="passwordConfirmFieldType"
                        :state="getValidationState(validationContext)"
                        v-model="newStaffData.password_confirmation"
                        name="password_confirmation"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordConfirmToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
              v-if="(newStaffData.id > 0 && ability.can('update', 'setting_staffs')) || (newStaffData.id == 0 && ability.can('create', 'setting_staffs'))"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import uploadFile from "@/layouts/components/file/uploadFile.vue";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      ability,
      required,
      email,
      idError: null,
      dragAndDropCapable: false,
      errorNameCnMessage: null,
      errorNameMessage: null,
      errorPhoneMessage: null,
      errorEmailMessage: null,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  methods: {
    hide() {
      //localStorage.setItem('activeTab', 1);
      this.$router.replace("/users/list");
    },
    // onFileUploaded(file) {
    //   this.newStaffData.image_files = file;
    // },
    workerStatusSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    roleSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    bankSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    paymentMethodSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },

    handlePhoneChange(){
      this.changePassword();
      this.checkUserPhone();
    },
    checkUserNameCn() {
      store.dispatch('app/checkUserNameCn', {
        id: this.newStaffData.id ? this.newStaffData.id : null,
        name_cn: this.newStaffData.name_cn
      }).then((response) => {
        this.errorNameCnMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameCnMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserName() {
      store.dispatch('app/checkUserName', {
        id: this.newStaffData.id ? this.newStaffData.id : null,
        name: this.newStaffData.name
      }).then((response) => {
        this.errorNameMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserPhone() {
      store.dispatch('app/checkUserPhone', {
        id: this.newStaffData.id ? this.newStaffData.id : null,
        phone: this.newStaffData.phone
      }).then((response) => {
        this.errorPhoneMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorPhoneMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserEmail() {
      store.dispatch('app/checkUserEmail', {
        id: this.newStaffData.id ? this.newStaffData.id : null,
        email: this.newStaffData.email
      }).then((response) => {
        this.errorEmailMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorEmailMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    onFileUploaded(file) {
      this.newStaffData.documents = file;
    },
    onSubmit() {
      if (this.idError || (this.newStaffData.id == 0 && this.newStaffData.file) && (this.errorEmailMessage || this.errorPhoneMessage))
        return;
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          let formData = new FormData();

          formData.append("id", this.newStaffData.id);
          formData.append("is_active", this.newStaffData.is_active ? 1 : 0);
          formData.append("name_cn", this.newStaffData.name_cn);
          formData.append("name", this.newStaffData.name);
          formData.append("email", this.newStaffData.email);
          formData.append("gender_id", this.newStaffData.gender_id);
          formData.append("id_number", this.newStaffData.id_number);
          if(this.newStaffData.date_of_birth){
            formData.append("date_of_birth", this.newStaffData.date_of_birth);
          }
          formData.append("phone", this.newStaffData.phone);
          if(this.newStaffData.address){
            formData.append("address", this.newStaffData.address);
          }
          if(this.newStaffData.bank_id){
            formData.append("bank_id", this.newStaffData.bank_id);
          }
          if(this.newStaffData.bank_account){
            formData.append("bank_account", this.newStaffData.bank_account);
          }
          if(this.newStaffData.bank_account_name){
            formData.append("bank_account_name", this.newStaffData.bank_account_name);
          }
          if(this.newStaffData.department){
            formData.append("department", this.newStaffData.department);
          }
          if(this.newStaffData.payment_method_id){
            formData.append("payment_method_id", this.newStaffData.payment_method_id);
          }

          formData.append("position", this.newStaffData.position);

          formData.append("join_date", this.newStaffData.join_date);

          formData.append("role_name", this.newStaffData.role_name);

          if (
            this.newStaffData.documents &&
            this.newStaffData.documents.length > 0
          ) {
            this.newStaffData.documents.forEach((item) => {
              formData.append("documents[]", item);
            });
          }
          if (
            this.newStaffData.id == 0
          ) {
            formData.append("password", this.newStaffData.password);
            formData.append(
              "password_confirmation",
              this.newStaffData.password_confirmation
            );
          }

          store
            .dispatch("app/checkUserNameCn", {
              id: this.newStaffData.id,
              name_cn: this.newStaffData.name_cn
            })
            .then(() => {
              store
                .dispatch("app/checkUserPhone", {
                  id: this.newStaffData.id,
                  phone: this.newStaffData.phone,
                })
              })
            .then(() => {
              if (this.newStaffData.email) {
                return store.dispatch("app/checkUserEmail", {
                  id: this.newStaffData.id,
                  email: this.newStaffData.email,
                });
              }
            })
            .then(() => {
              // 只有在 checkUserPhone 成功後才執行 addCustomer
              return store.dispatch(
                "staff/addStaff",
                formData
              );
            })
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(
                  error.response?.data?.message || error.message
                ),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    IsHKID(str) {
      return true;
      var strValidChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

      // basic check length
      if (str.length < 8) {
        this.idError = "身份證號碼" + str + "不正確";
        return false;
      }

      // handling bracket
      if (
        str.charAt(str.length - 3) == "(" &&
        str.charAt(str.length - 1) == ")"
      )
        str = str.substring(0, str.length - 3) + str.charAt(str.length - 2);

      // convert to upper case
      str = str.toUpperCase();

      // regular expression to check pattern and split
      var hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;

      var matchArray = str.match(hkidPat);

      // not match, return false
      if (matchArray == null) {
        this.idError = "身份證號碼" + str + "不正確";
        return;
      }

      // the character part, numeric part and check digit part
      var charPart = matchArray[1];
      var numPart = matchArray[2];
      var checkDigit = matchArray[3];

      // calculate the checksum for character part
      var checkSum = 0;
      if (charPart.length == 2) {
        checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
        checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
      } else {
        checkSum += 9 * 36;
        checkSum += 8 * (10 + strValidChars.indexOf(charPart));
      }

      // calculate the checksum for numeric part
      for (var i = 0, j = 7; i < numPart.length; i++, j--)
        checkSum += j * numPart.charAt(i);

      // verify the check digit
      var remaining = checkSum % 11;
      var verify = remaining == 0 ? 0 : 11 - remaining;

      if (verify == checkDigit || (verify == 10 && checkDigit == "A")) {
        this.idError = "";
      } else {
        this.idError = "身份證號碼" + str + "不正確";
      }
    },
    changePassword(){
      this.newStaffData.password = "WFdc_" + this.newStaffData.phone.toString().slice(-4);
      this.newStaffData.password_confirmation = "WFdc_" + this.newStaffData.phone.toString().slice(-4);
    },
  },
  props: {
    staffData: {
      type: Object,
      required: true,
    },
    genderOptions: {
      type: Array,
      required: true,
    },
    bankOptions: {
      type: Array,
      required: true,
    },
    paymentMethodStatusOptions: {
      type: Array,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newStaffData = ref({ id: 0, is_active: 1 });

    const props_previewImage = ref([]);
    watch(
      () => props.staffData,
      (newVal) => {
        newStaffData.value = { ...newVal };
        if (newVal.documents) {
          props_previewImage.value = [...newVal.documents];
        }
      }
    );
    const staffStatusOptions = [
      {
        id: 1,
        name: "在職",
      },
      {
        id: 0,
        name: "離職",
      },
    ];

    watch(
      () => props.staffData,
      (newVal) => {
        newStaffData.value = { ...newVal };
      }
    );
    const resetWorkData = () => {
      newStaffData.value = JSON.parse(
        JSON.stringify({
          id: 0, is_active: 1
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

      const passwordFieldType = ref('password')
    const passwordConfirmFieldType = ref('password')

    const togglePasswordVisibility = () => {
      passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password'
       passwordConfirmFieldType.value = passwordConfirmFieldType.value === 'password' ? 'text' : 'password'
    }

    const passwordToggleIcon = computed(() => (passwordFieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))
    const passwordConfirmToggleIcon = computed(() => (passwordConfirmFieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newStaffData,
      staffStatusOptions,
      passwordFieldType,
      passwordConfirmFieldType,
      togglePasswordVisibility,
      passwordToggleIcon,
      passwordConfirmToggleIcon,
      props_previewImage
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
